import { cn, NoddiIcon } from 'noddi-ui-common';
import { LanguageCodeType } from 'noddi-util';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../base/dropdown-menu';
import { useIsWithinTailWindBreakpoint } from '../../hooks/useIsWithinTailWindBreakpoint';
import { SupportedLanguages } from '../../types/lingui';
import { NoddiButton } from '../Inputs/NoddiButton';
type NoddiLanguageSelectorProps = {
  supportedLanguages: SupportedLanguages;
  currentLanguage: LanguageCodeType;
  setCurrentLanguage: (locale: LanguageCodeType) => void;
  dropDownOnRightSide?: boolean;
  collapseOnMobile?: boolean;
  className?: string;
};

export const NoddiLanguageSelector = ({
  supportedLanguages,
  currentLanguage,
  setCurrentLanguage,
  dropDownOnRightSide,
  collapseOnMobile,
  className
}: NoddiLanguageSelectorProps) => {
  const options = Object.entries(supportedLanguages).map(([locale, details]) => ({
    value: locale as LanguageCodeType,
    label: details.label,
    flag: details.flag
  }));

  const currentLanguageDetails = supportedLanguages[currentLanguage];
  const isMd = useIsWithinTailWindBreakpoint('md');

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <NoddiButton variant='outline' size={isMd ? 'small' : 'default'} className={cn('group border-none', className)}>
          <div className='flex items-center gap-1 sm:gap-4'>
            <span>{currentLanguageDetails?.flag}</span>
            {/* Hidden visually rather than removed: the flag emoji alone leaves the trigger unnamed. */}
            <span className={cn(collapseOnMobile && 'sr-only sm:not-sr-only')}>{currentLanguageDetails?.label}</span>
            <div className='transition-transform duration-300 ease-out group-data-[state=open]:rotate-180'>
              <NoddiIcon name='ChevronDown' />
            </div>
          </div>
        </NoddiButton>
      </DropdownMenuTrigger>

      <DropdownMenuContent align={dropDownOnRightSide ? 'end' : 'start'}>
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            className={cn(
              'flex w-full justify-between gap-5 p-2 text-black',
              '[&:not(:last-child)]:border-b-[1.5px] [&:not(:last-child)]:border-outlineStroke',
              option.value === currentLanguage && 'font-bold'
            )}
            onSelect={() => {
              setCurrentLanguage(option.value);
            }}
          >
            <div className='flex items-center gap-2'>
              <span className='w-10'>{option.flag}</span>
              <span>{option.label}</span>
            </div>

            <div className='ml-auto flex size-5 items-center justify-center rounded-full border border-outlineStroke'>
              {option.value === currentLanguage && <div className='size-4 rounded-full bg-noddiPurple' />}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
